export default __webpack_public_path__ + "static/media/ComputerPowerSupplyImg.206268b7.jpg";